import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "338.799",
  height: "353.733",
  viewBox: "0 0 89.641 93.592"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { style: {"font-weight":"700","font-size":"123.472px","font-family":"\"Neue Haas Grotesk Text Pro\"","-inkscape-font-specification":"\"Neue Haas Grotesk Text Pro Bold\"","fill":"#a9bacd","stroke-width":".264583","fill-opacity":"1"} }, [
      _createElementVNode("path", {
        d: "M204.335 132.388c-2.346-22.842-17.533-36.3-44.697-36.3-24.818 0-44.327 17.903-44.327 46.672 0 28.892 17.78 46.92 47.167 46.92 23.46 0 39.881-13.83 42.474-36.795h-28.028c-1.111 8.52-5.556 15.063-14.94 15.063-14.817 0-17.533-11.73-17.533-24.2 0-17.163 6.173-25.93 16.421-25.93 9.137 0 14.94 5.31 15.805 14.57z",
        "aria-label": "C",
        style: {"font-weight":"900","font-family":"\"Helvetica LT Std\"","-inkscape-font-specification":"\"Helvetica LT Std Heavy\"","fill":"#a9bacd","fill-opacity":"1"},
        transform: "translate(-115.311 -96.087)"
      })
    ], -1)
  ])))
}
export default { render: render }